import React, { Component } from "react";

import bag from "assets/graphics/pictures/bag.jpg";
import people from "assets/graphics/pictures/people.jpg";
import wine from "assets/graphics/pictures/wine.jpg";
import photographs from "assets/graphics/pictures/photographs.jpg";
import shirt from "assets/graphics/pictures/shirt.jpg";
import hands from "assets/graphics/pictures/hands.jpg";
import tea from "assets/graphics/pictures/tea.jpg";
import villa from "assets/graphics/pictures/villa.jpg";
import body from "assets/graphics/pictures/body.jpg";

import CarouselView from "features/new/carousel/view";

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemImages: [
        { image: bag, alternate: "social club - fashion events" },
        { image: people, alternate: "social club - art events" },
        { image: wine, alternate: "social club - gatherings and parties" },
        { image: photographs, alternate: "social club - creatives networking" },
        { image: shirt, alternate: "social club - business networking" },
        { image: hands, alternate: "meet new people in parlor social club" },
        { image: tea, alternate: "attend unique events in parlor social club" },
        { image: villa, alternate: "members-only events new york city" },
        { image: body, alternate: "parlor social club membership" },
      ],
      activeItemIndex: 3,
      carouselPosition: 0,
      isTransitioned: true,
      isSpun: false,
      carouselWidth: 0,
      itemWidth: 0,
      activeItemWidth: 0,
      swipePosition: 0,
    };

    this.references = {
      carouselContainer: React.createRef(),
      carouselItem: React.createRef(),
      carouselItemActive: React.createRef(),
    };

    this.goToPreviousItem = this.goToPreviousItem.bind(this);
    this.goToNextItem = this.goToNextItem.bind(this);
    this.setSwipePosition = this.setSwipePosition.bind(this);
    this.swipe = this.swipe.bind(this);
  }

  componentDidMount() {
    let itemImages = [...this.state.itemImages];
    let itemImagesBegining = itemImages.slice(0, 3);
    let itemImagesEnd = itemImages.slice(
      itemImages.length - 3,
      itemImages.length
    );

    itemImages = itemImagesEnd.concat(itemImages);
    itemImages = itemImages.concat(itemImagesBegining);

    this.setState({ itemImages });

    this.setCarouselDimensions();

    window.addEventListener("load", () => this.setCarouselDimensions());
    window.addEventListener("resize", () => this.setCarouselDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener("load", () => this.setCarouselDimensions());
    window.removeEventListener("resize", () => this.setCarouselDimensions());
  }

  setCarouselDimensions() {
    if (
      this.references.carouselContainer.current &&
      this.references.carouselItem.current &&
      this.references.carouselItemActive.current
    ) {
      this.setState(
        {
          isTransitioned: false,
          carouselWidth: this.references.carouselContainer.current.clientWidth,
          itemWidth: this.references.carouselItem.current.clientWidth,
          activeItemWidth: this.references.carouselItemActive.current
            .clientWidth,
        },
        () => this.setCarouselPosition(this.state.activeItemIndex)
      );
    }
  }

  setCarouselPosition(activeItemIndex) {
    let { carouselWidth, itemWidth, activeItemWidth } = this.state;

    this.references.carouselContainer.current &&
      this.setState({
        carouselPosition:
          (carouselWidth -
            (activeItemIndex * 2 * itemWidth + activeItemWidth)) /
          2,
      });
  }

  goToPreviousItem() {
    if (!this.state.isSpun) {
      let { activeItemIndex } = this.state;

      if (activeItemIndex - 1 > 1) {
        activeItemIndex = activeItemIndex - 1;

        this.setState(
          { activeItemIndex, isTransitioned: true, isSpun: true },
          () => this.setCarouselPosition(activeItemIndex)
        );

        setTimeout(() => this.setState({ isSpun: false }), 400);

        if (activeItemIndex - 1 <= 1) {
          setTimeout(() => {
            activeItemIndex = this.state.itemImages.length - 4;

            this.setState({ activeItemIndex, isTransitioned: false }, () =>
              this.setCarouselPosition(activeItemIndex)
            );
          }, 400);
        }
      }
    }

    window.dataLayer.push({ event: "previousCarouselItemClicked" });
  }

  goToNextItem() {
    if (!this.state.isSpun) {
      let { activeItemIndex } = this.state;

      if (activeItemIndex + 1 < this.state.itemImages.length - 2) {
        activeItemIndex = activeItemIndex + 1;

        this.setState(
          { activeItemIndex, isTransitioned: true, isSpun: true },
          () => this.setCarouselPosition(activeItemIndex)
        );

        setTimeout(() => this.setState({ isSpun: false }), 400);

        if (activeItemIndex + 1 >= this.state.itemImages.length - 2) {
          setTimeout(() => {
            activeItemIndex = 3;

            this.setState({ activeItemIndex, isTransitioned: false }, () =>
              this.setCarouselPosition(activeItemIndex)
            );
          }, 400);
        }
      }
    }

    window.dataLayer.push({ event: "nextCarouselItemClicked" });
  }

  setSwipePosition(event) {
    this.setState({ swipePosition: event.pageX || event.touches[0].pageX });
  }

  swipe(event) {
    let { swipePosition } = this.state;

    let x = event.pageX || event.touches[0].pageX;

    swipePosition - x >= 80
      ? this.setState({ swipePosition: x }, this.goToNextItem())
      : swipePosition - x <= -80 &&
        this.setState({ swipePosition: x }, this.goToPreviousItem());
  }

  render() {
    const {
      itemImages,
      activeItemIndex,
      carouselPosition,
      isTransitioned,
    } = this.state;

    return (
      <CarouselView
        itemImages={itemImages}
        activeItemIndex={activeItemIndex}
        carouselPosition={carouselPosition}
        isTransitioned={isTransitioned}
        references={this.references}
        goToPreviousItem={this.goToPreviousItem}
        goToNextItem={this.goToNextItem}
        setSwipePosition={this.setSwipePosition}
        swipe={this.swipe}
      />
    );
  }
}

export default Carousel;
